import {
  ApiError,
  ConflictError,
  DuplicateError,
  ForbiddenError,
  FulfillmentError,
  NotFoundError,
} from '../../api/errors';

/** Operator-facing text for a stock API error; never the raw server message. */
export function stockErrorMessage(error: unknown, fallback: string, what = 'record'): string {
  if (error instanceof FulfillmentError) {
    switch (error.reason) {
      case 'INSUFFICIENT_STOCK':
        return 'There isn’t that much available there. Reserved stock can’t be moved or adjusted away.';
      case 'INACTIVE':
        return 'The stock item or location is deactivated.';
      case 'INVALID_STATE':
        return 'A location that still holds stock can’t be deactivated. Move the stock first.';
      case 'IDEMPOTENCY_KEY_REUSED':
        return 'This request conflicts with an earlier one. Close the form and try again.';
      default:
        return fallback;
    }
  }
  if (error instanceof DuplicateError) {
    const owner = /stock item (\S+) already uses/.exec(error.message)?.[1];
    if (owner) return `A barcode or the SKU is already used by stock item ${owner}.`;
    return `That ${what} code is already in use.`;
  }
  if (error instanceof ConflictError) {
    return `Someone else changed this ${what}. Close it and open it again to see their changes.`;
  }
  if (error instanceof ForbiddenError) {
    return 'You don’t have permission to change stock. Sign in with a @tidalx.ai account.';
  }
  if (error instanceof NotFoundError) return `This ${what} no longer exists.`;
  if (error instanceof ApiError && error.code === 'NETWORK') {
    return 'The server could not be reached. Check the connection and try again.';
  }
  return fallback;
}

export function isUnknownOutcome(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'NETWORK';
}
